document.addEventListener('DOMContentLoaded', function(){

  /* Main product page */
  document.querySelectorAll('[data-navyr]').forEach(function(root){
    const offers = root.querySelectorAll('[data-offer]');
    const variantInput = root.querySelector('[data-variant-id]');
    const livePrice = root.querySelector('[data-live-price]');
    const selectionName = root.querySelector('[data-selection-name]');
    const form = root.querySelector('[data-navyr-buy-form]');
    const buy = root.querySelector('[data-buy]');
    const qtyInput = root.querySelector('[data-qty-input]');
    const qtyMinus = root.querySelector('[data-qty-minus]');
    const qtyPlus = root.querySelector('[data-qty-plus]');

    function clampQty(value){
      const n = parseInt(value || '1', 10);
      if(isNaN(n)) return 1;
      return Math.min(20, Math.max(1, n));
    }

    if(qtyMinus && qtyInput){
      qtyMinus.addEventListener('click', function(){
        qtyInput.value = clampQty(parseInt(qtyInput.value || '1',10) - 1);
      });
    }
    if(qtyPlus && qtyInput){
      qtyPlus.addEventListener('click', function(){
        qtyInput.value = clampQty(parseInt(qtyInput.value || '1',10) + 1);
      });
    }
    if(qtyInput){
      qtyInput.addEventListener('change', function(){
        qtyInput.value = clampQty(qtyInput.value);
      });
    }

    function variantForOffer(offer){
      const select = offer.querySelector('[data-offer-variant-select]');
      if(select){
        const option = select.options[select.selectedIndex];
        return {
          id: select.value,
          price: option ? option.dataset.price : offer.dataset.defaultPrice
        };
      }
      return {id: offer.dataset.defaultVariant, price: offer.dataset.defaultPrice};
    }

    function activate(offer){
      offers.forEach(o => o.classList.remove('active'));
      offer.classList.add('active');
      const v = variantForOffer(offer);
      if(variantInput) variantInput.value = v.id || '';
      if(livePrice) livePrice.textContent = v.price || '';
      if(selectionName) selectionName.textContent = offer.dataset.offerName || 'NAVYR';
    }

    offers.forEach(function(offer){
      offer.addEventListener('click', function(e){
        if(e.target.closest('select')) return;
        activate(offer);
      });

      const select = offer.querySelector('[data-offer-variant-select]');
      if(select){
        select.addEventListener('change', function(){
          activate(offer);
          const priceNode = offer.querySelector('[data-offer-price]');
          const option = select.options[select.selectedIndex];
          if(priceNode && option) priceNode.textContent = option.dataset.price || '';
        });
      }
    });

    if(offers.length){
      activate(Array.from(offers).find(o => o.classList.contains('active')) || offers[0]);
    }

    if(form && buy){
      form.addEventListener('submit', async function(e){
        e.preventDefault();
        if(!variantInput || !variantInput.value) return;

        buy.disabled = true;
        const previous = buy.textContent;
        buy.textContent = 'AJOUT...';

        try{
          const body = new FormData();
          body.append('id', variantInput.value);
          body.append('quantity', String(clampQty(qtyInput ? qtyInput.value : 1)));

          const res = await fetch('/cart/add.js',{
            method:'POST',
            headers:{'Accept':'application/json'},
            body
          });
          if(!res.ok) throw new Error('cart');

          window.location.href = '/cart';
        }catch(err){
          buy.disabled = false;
          buy.textContent = previous;
        }
      });
    }

    const trackerBtn = root.querySelector('[data-tracker-buy]');
    if(trackerBtn){
      trackerBtn.addEventListener('click', async function(){
        const id = trackerBtn.dataset.trackerVariant;
        if(!id) return;

        const previous = trackerBtn.textContent;
        trackerBtn.disabled = true;
        trackerBtn.textContent = 'AJOUT...';

        try{
          const body = new FormData();
          body.append('id', id);
          body.append('quantity', '1');

          const res = await fetch('/cart/add.js',{
            method:'POST',
            headers:{'Accept':'application/json'},
            body
          });
          if(!res.ok) throw new Error('cart');

          window.location.href = '/cart';
        }catch(err){
          trackerBtn.disabled = false;
          trackerBtn.textContent = previous;
        }
      });
    }
  });

  /* Cart page steppers */
  document.querySelectorAll('.nv-cart-item').forEach(function(item){
    const input = item.querySelector('[data-cart-qty]');
    const minus = item.querySelector('[data-cart-minus]');
    const plus = item.querySelector('[data-cart-plus]');

    if(!input) return;

    function clampCartQty(value){
      const n = parseInt(value || '0',10);
      if(isNaN(n)) return 1;
      return Math.min(20, Math.max(0, n));
    }

    if(minus){
      minus.addEventListener('click', function(){
        input.value = clampCartQty(parseInt(input.value || '1',10) - 1);
      });
    }
    if(plus){
      plus.addEventListener('click', function(){
        input.value = clampCartQty(parseInt(input.value || '1',10) + 1);
      });
    }
  });

});
